<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Aetheletics/Sports</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Aetheletics/Sports</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="about-institute ptb--100">
  <div class="container">
    <div class="row">
      <div class="col">
        <h4 class="yellow-color fw-bold mb-2">Sports Facilities</h4>
        <blockquote class="blockquote-div">
          <p>Sports teaches you character, it teaches you to play by the rules, it teaches you to know what it feels
            like to win and lose-it teaches you about life.
          </p>
          <h6>- Billie Jean King</h6>
        </blockquote>
        <p>Inevitably Sports and Games make an indispensable part of the curriculum of our educational institutes. They
          are the carrier of a healthy mind, a healthy body and a free soul. They aid in the development of social
          skills. They reduce stress. They make sure that co-operation and coordination becomes the part and parcel of
          the lives of the student.</p>
        <div class="row row-cols-2 justify-content-center align-items-top mt-3">
          <div class="accordion accordian-class" id="accordionExample1">
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#attributes" aria-expanded="true" aria-controls="collapseOne">
                The attributes we eye on
              </h2>
              <div id="attributes" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample1">
                <div class="accordion-body">
                  <ul class="list-before">
                    <li><strong>Comprehensive assistance : </strong> Comprehensive assistance by the lab faculty and
                      educators to assist you with any issues arising in the operation of equipment or software. They
                      are well versed with their job and will be a helping hand as and when needed. </li>
                    <li><strong>High Speed Internet : </strong> Our laboratory is coupled with high speed internet. You
                      can be assured of seamless working with the same. </li>
                    <li><strong>Latest Configuration: </strong> Our computers are associated with the latest
                      configuration to aid you in better processing. This is not it. The software of the computer is
                      upgraded from time to time. Thus, you will be able to take benefits of the latest with the
                      laboratory.</li>
                    <li><strong>Hands-on-Practical : </strong> We comprehend the need of hand-on-practical experience
                      for our students. Hence, we have a good number of computers in our laboratory to suffice the need.
                    </li>
                  </ul>
                  <p> As the pioneer institute providing holistic education, we have the best sports facility with us to
                    take care of all of the above. </p>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion accordian-class" id="accordionExample2">
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#facilities" aria-expanded="true" aria-controls="collapseOne">
                Our Sports Facilities
              </h2>
              <div id="facilities" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample2">
                <div class="accordion-body">
                  <h5>Here are some key pointers describing them well :</h5>
                  <ul class="list-before">
                    <li><b>Outdoor Games : </b> Outdoor games like badminton, football, basketball, and cricket have
                      specifications with respect to the field needs. We have it all on our campus. We make sure to
                      provide with amenities which are best in the class to provide the students with unsurpassed
                      playing experience right here in our fields.</li>
                    <li><b>Indoor Games : </b> Finest of the indoor games facilities lie with our institute. We have
                      table tennis, chess, and carom as the part of the indoor sports activities for our students. The
                      students can spend their time in engaging in the sports arena of our indoor games with ease. </li>
                    <li><b>Sports in charge : </b> We do comprehend the need of sports in charge in every sport. Thus,
                      we have appointed the teachers for both indoor and outdoor game to guide the aspiring sports
                      person well. They are excellent in their field. They have complete knowledge about the rules and
                      regulations. We do have a sports coordinator in each class to encourage the students.</li>
                    <li><b>Competitions : </b> In order to inculcate a sportsman spirit in the students, time and again
                      sports competition are held in the college. There are held the inter class competitions. And,
                      there are also organized the Intercollegiate sports meet. This inspires the students, enables them
                      knowledge about the level of competition and prepares them for future endeavors.</li>
                    <li><b>First Aid Box : </b> Complete care is taken at the college premises to keep it safe for the
                      students playing sports. However, if during some sports event or regular games a student gets hurt
                      the sports facility has the first aid box to aid them with medical assistance. </li>
                    <li><b>Sports Dignitaries : </b> The best sportsperson in the various sports, the sports
                      personality, those that have made the nation proud with their milestone achievements are a
                      treasure to the society. In order to inculcate the students with supreme aims, they are invited by
                      our institute to give lectures about the games.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="mb-2">Fitness of body, mind and soul is the vision we have for our students at our institute.</p>
        <blockquote class="blockquote-div mb-4">
          <p>Play well! Live well! Stay healthy!
          </p>
        </blockquote>
        <div>
          <iframe src="https://drive.google.com/file/d/1_uRBfENLpRVy3dMoVYWmTookxAkZw0fZ/preview" type="application/pdf"
            width="100%" height="800"></iframe>
        </div>
      </div>
    </div>
  </div>
</section>
